var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layer',{ref:"layer",attrs:{"config":_vm.config}},[(_vm.layer.config.enabled && _vm.layer.image)?_c('v-image',{attrs:{"config":{image: _vm.layer.image}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }